var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 378,
    viewBox: "0 0 378 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10038_1928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189 189C241.191 189 283.5 146.691 283.5 94.5C283.5 42.3091 241.191 0 189 0C136.809 0 94.5 42.3091 94.5 94.5C94.5 146.691 136.809 189 189 189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 221.398C110.75 221.486 47.3371 284.898 47.25 363.148C47.25 371.847 54.3013 378.898 62.9998 378.898H315C323.698 378.898 330.749 371.847 330.749 363.148C330.663 284.898 267.25 221.485 189 221.398Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10038_1928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 378,
    height: 378,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.946cd3464b66e28c4f9f71a008c04019.svg";
export { ForwardRef as ReactComponent };